import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="py-4">
      <div className="sm:flex sm:items-center mb-6">
        <div className="sm:flex-auto">
          <div className="animate-pulse h-7 w-64 bg-gray-200 dark:bg-gray-700 rounded"></div>
          <div className="mt-2 animate-pulse h-5 w-96 bg-gray-100 dark:bg-gray-800 rounded"></div>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 animate-pulse">
          <div className="h-10 w-36 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
        </div>
      </div>
      
      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 dark:ring-white dark:ring-opacity-5 sm:rounded-lg">
        <div className="animate-pulse">
          {/* Table header placeholder */}
          <div className="bg-gray-50 dark:bg-gray-800 h-14"></div>
          
          {/* Table rows placeholders */}
          {[...Array(8)].map((_, index) => (
            <div key={index} className="divide-y divide-gray-200 dark:divide-gray-700">
              <div className="h-16 bg-gray-100 dark:bg-gray-800 flex">
                <div className="w-1/4 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
                  <div className="h-3 mt-2 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                  <div className="h-3 mt-2 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                  <div className="h-3 mt-2 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
                </div>
                <div className="w-1/6 p-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
                </div>
              </div>
            </div>
          ))}
          
          {/* Footer placeholder */}
          <div className="h-16 bg-gray-50 dark:bg-gray-700 flex items-center">
            <div className="w-1/4 p-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-24"></div>
            </div>
            <div className="w-3/4 p-4 flex justify-end space-x-8">
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-32"></div>
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-32"></div>
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-32"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;